import { combineReducers } from 'redux';
import { userReducer } from './userReducer';
import authenticationReducer from './authenticationReducer';
import { gamesReducer } from './gameReducer';
import { rewardPositionReducer } from './rewardPositionReducer';
import { islandsReducer } from './islandReducer';
import { islandThemesReducer } from './islandThemeReducer';
import { rewardCategoriesReducer } from './rewardCategoryReducer';
import { passwordResetReducer } from './passwordResetReducer';
import { gameScoresReducer } from './gameScore';
import { schoolReducer } from './schoolReducer';
import { leaderboardGameScoresReducer } from './leaderboardGameScoresReducer';

export default combineReducers({
  users: userReducer,
  authentication: authenticationReducer,
  games: gamesReducer,
  rewardCategories: rewardCategoriesReducer,
  rewardPositions: rewardPositionReducer,
  islands: islandsReducer,
  islandThemes: islandThemesReducer,
  passwordResets: passwordResetReducer,
  gameScores: gameScoresReducer,
  schools: schoolReducer,
  leaderboardGameScores: leaderboardGameScoresReducer,
});
